import { notification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';
import React, { createContext, useContext } from 'react';

type NotificationContextType = NotificationInstance;

const NotificationContext = createContext<NotificationContextType | null>(null);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [api, contextHolder] = notification.useNotification();

  return (
    <NotificationContext.Provider value={api}>
      {contextHolder} {/* Must be rendered */}
      {children}
    </NotificationContext.Provider>
  );
};

export const useAppNotification = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    throw new Error(
      'useAppNotification must be used within NotificationProvider'
    );
  }
  return ctx;
};
